import React from 'react'

const CaseStudies = () => {
    return (
        <div className='page'>
            <div className="container">
                <div className="row">
                    <div className="h3">This is the case studies page</div>
                </div>
            </div>
        </div>
    )
}

export default CaseStudies
